import { useEffect, useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useCarouselImages } from "../Hooks/layout/useCarouselImages";

const BackgroundCarousel = () => {
    const { files } = useCarouselImages();
    const carouselRef = useRef();

    const responsive = {
        desktop: {
            breakpoint: { max: 5000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 768 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1
        }
    };

    useEffect(() => {
        if (files?.activeImages?.length > 1 && carouselRef.current) {
            const interval = setInterval(() => {
                carouselRef.current?.next();
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [files?.activeImages]);

    const itemTemplate = (item) => {
        const commonStyle = {
            width: "100%",
            height: "100%",
            objectFit: "fill",
            objectPosition: "center"
        };

        if (item?.carousel_image_Path?.endsWith(".mp4")) {
            return (
                <video
                    src={item.carousel_image_Path}
                    style={commonStyle}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    disablePictureInPicture
                    disableRemotePlayback
                />
            );
        }

        return (
            <img
                src={item.carousel_image_Path}
                alt={`Slide ${item?.carousel_mapping_id}`}
                style={{
                    ...commonStyle,
                    transition: "opacity 0.5s ease-in-out"
                }}
            />
        );
    };

    return (
        <>
            {files?.activeImages?.length > 0 && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        zIndex: 1,
                        height: "100vh",
                        width: "100vw"
                    }}
                >
                    <Carousel
                        ref={carouselRef}
                        swipeable={false}
                        draggable={false}
                        showDots={false}
                        responsive={responsive}
                        ssr={true}
                        infinite={files?.activeImages?.length > 1}
                        autoPlay={files?.activeImages?.length > 1}
                        autoPlaySpeed={5000}
                        keyBoardControl={false}
                        customTransition="transform 0.5s ease-in-out"
                        transitionDuration={500}
                        containerClass="carousel-container"
                        itemClass="carousel-item-fullscreen"
                        slidesToSlide={1}
                        pauseOnHover="none"
                        shouldResetAutoplay={false}
                    >
                        {files.activeImages.map((item, index) => (
                            <div
                                key={item.carousel_mapping_id || index}
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    overflow: "hidden"
                                }}
                            >
                                {itemTemplate(item)}
                            </div>
                        ))}
                    </Carousel>
                </div>
            )}
        </>
    );
};

export default BackgroundCarousel;
